import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Questions.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IQuestions } from "./IQuestions";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import QuestionsForm from "./QuestionsForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import {
  Button,
  ButtonGroup,
  IconButton,
  SvgIcon,
  TextField,
  Alert,
  AlertTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import FolderZipIcon from '@mui/icons-material/FolderZip';
import ImageIcon from '@mui/icons-material/Image';
import LinkIcon from '@mui/icons-material/Link';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
// import ClearIcon from '@mui/icons-material/Clear';
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listQuestions } from "../../Redux/Slices/Questions/ListQuestionsSlice";
import { clearAddQuestionsResponse } from "../../Redux/Slices/Questions/AddQuestionsSlice";
import {
  clearDeleteQuestionsResponse,
  deleteQuestions,
} from "../../Redux/Slices/Questions/DeleteQuestionsSlice";
import { clearEditQuestionsResponse } from "../../Redux/Slices/Questions/EditQuestionsSlice";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import {
  clearReadingPrompt,
  listReadingPrompt,
} from "../../Redux/Slices/ReadingPrompt/ListReadingPromptSlice";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { listYearGroup } from "../../Redux/Slices/User/ListYearGroupSlice";
import OnlineExamTamplete from "../PageTamplete/OnlineExampageTamplete/OnlineExampageTamplete";
import UcatExamTemplate from "./UcatExamTemplate";
import QuestionSubType from "../QuestionSubType/QuestionSubType";
import {
  clearlistQuestionSubTypeResponse,
  listQuestionSubType,
} from "../../Redux/Slices/QuestionSubType/ListQuestionSubTypeSlice";
import ClearIcon from "@mui/icons-material/Clear";
import CustomFooter from "../../Components/Table/components/CustomFooter";
import { listYearlevel_map, ListYearlevel_mapSlice } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";
import { bulkUploadQuestions, clearBulkUploadQuestionsResponse } from "../../Redux/Slices/Questions/BulkUploadQuestionsSlice";
import api from "../../Redux/Axios/middleware";

interface QuestionsProps { }
interface Question {
  label: string;
  value: number;
}
interface YearList {
  // interface DifficultyOption {
  label: string;
  value: number;
}

// const DifficultyLevel: DifficultyOption[] = [
//   { label: "Easy", value: "easy" },
//   { label: "Moderate", value: "moderate" },
//   { label: "Hard", value: "difficult" },
// ];

// Utility function for tick and cross marks
const renderTickCross = (value: boolean) => {
  return (
    <span className={value ? "tick-mark" : "cross-mark"}>
      {value ? "✓" : "✗"}
    </span>
  );
};

const Questions: FunctionComponent<QuestionsProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [bulkUploadInfoOpen, setBulkUploadInfoOpen] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IQuestions>({
    Status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listQuestionss } = useAppSelector(
    (state) => state.ListQuestionsSlice
  );
  const { data: addQuestions } = useAppSelector(
    (state) => state.AddQuestionsSlice
  );
  const { data: EditQuestions } = useAppSelector(
    (state) => state.EditQuestionsSlice
  );
  const { data: deleteQuestionss } = useAppSelector(
    (state) => state.DeleteQuestions
  );
  const { data: bulkUploadResponse } = useAppSelector(
    (state) => state.BulkUploadQuestionsSlice
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const navigate = useNavigate();

  const formRef = useRef<HTMLFormElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [previewItem, setPreviewItem] = useState<IQuestions | null>(null);
  const [previewType, setPreviewType] = useState<"ucat" | "online" | null>(null);

  const columns: Columns = [
    {
      field: "index",
      headerName: "S.No",

      // renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "question",
      headerName: "Question",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "subType_name",
      headerName: "Sub Type",
      // renderHeader: () => <b>Questions</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "Question_type_name",
      headerName: "Question Type Name",

      // renderHeader: () => <b>Question Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "prompt",
      headerName: "Prompt",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "instruction",
      headerName: "Instruction",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "explanation",
      headerName: "Explanation",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },

    // {
    //   field: "difficulty_level",
    //   headerName: "Difficulty Level",
    //   // renderHeader: () => <b>Difficulty Level</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    // {
    //   field: "year_level",
    //   headerName: "Year Level",
    //   // renderHeader: () => <b>Difficulty Level</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "source_type",
      headerName: "Source Type",
      // renderHeader: () => <b>Source Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "answer_type",
      headerName: "Answer Type",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "free_tier",
      headerName: "Free Tier",
      flex: 1,
      type: "boolean",
      headerAlign: "left",
      align: "left",
      renderCell: (params) => renderTickCross(params.value),
    },
    {
      field: "imgWidth",
      headerName: "Image Width",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "promptImgWidth",
      headerName: "Prompt Width",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "yeargroup_region",
      headerName: "Year Group",
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<IQuestions>) => {
        const yearGroupIds = params.row.yeargroup_region || [];
        const yearGroupNames = yearGroupIds.map((id: number) => {
          const yearGroupMap = ListYear?.data?.find((map: any) => map.id === id);
          return yearGroupMap?.yeargroup?.name || `ID: ${id}`;
        });
        return yearGroupNames.join(", ") || "-";
      },
    },
    {
      field: "state",
      headerName: "Status",
      // renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",

      cellClassName: (params) =>
        `activename ${params.row.state === "active" ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === "active" ? "Active" : "Inactive",
    },
    {
      field: "action",
      headerName: "Action",
      // renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IQuestions>) => {
        return (
          <>
            <RemoveRedEyeIcon
              titleAccess="Review Exam question page"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                console.log("params.row", params.row);
                // Check if Year 12 is present in year_levels
                const hasYear12 = Array.isArray(params.row.year_levels) && params.row.year_levels.some((y: any) =>
                  (typeof y === 'string' && y.includes("Year 12")) ||
                  (y?.name && y.name.includes("Year 12"))
                );

                setPreviewItem(params.row);
                if (hasYear12) {
                  setPreviewType("ucat");
                } else {
                  setPreviewType("online");
                }
              }}
            ></RemoveRedEyeIcon>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
                dispatch(clearReadingPrompt());
                dispatch(listReadingPrompt({}));
                dispatch(
                  listQuestionSubType({
                    questiontype_id: params.row.questionType,
                  })
                );
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  // name: params?.row?.explanation,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];
  const [page, setPage] = useState<number>(1);

  const pagination = listQuestionss?.data?.pagination;

  const currentPage = pagination?.current_page ?? 1;
  const totalPages = pagination?.total_pages ?? 0;
  const pageSize = pagination?.page_size ?? 20;

  useEffect(() => {
    if (pagination?.current_page && pagination.current_page !== page) {
      setPage(pagination.current_page);
    }
  }, [pagination?.current_page]);

  const Questions = Array.isArray(listQuestionss?.data.questions)
    ? listQuestionss?.data.questions.map((user: any, index: number) => ({
      ...user,
      index: (page - 1) * pageSize + index + 1,
    }))
    : [];

  // Derived state for filtered questions
  const visibleQuestions = React.useMemo(() => {
    return Questions?.filter((item: any) => item.Status === isActive) || [];
  }, [Questions, isActive]);

  useEffect(() => {
    dispatch(listQuestionType());
    // dispatch(listQuestions({}));
    dispatch(listYearlevel_map());
    dispatch(listReadingPrompt({}));
    // dispatch(listSideMenuPermission());
    dispatch(listYearGroup());
  }, [dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddQuestionsResponse());
      dispatch(clearEditQuestionsResponse());
      dispatch(clearDeleteQuestionsResponse());
      dispatch(clearlistQuestionSubTypeResponse());
      dispatch(clearBulkUploadQuestionsResponse());
    };
  }, []);

  const { data: listQuestionstype } = useAppSelector(
    (state) => state.ListQuestionTypeSlice
  );

  const QuestionList: any = Array.isArray(listQuestionstype?.data)
    ? listQuestionstype?.data
      ?.filter((role) => role.Status !== false) // Filter out roles where status is false
      .map((listQuestions) => ({
        label: listQuestions?.name!,
        value: listQuestions.id,
      }))
    : [];
  const [selectedValue, setSelectedValue] = useState<Question | null>(() =>
    JSON.parse(sessionStorage.getItem("selectedValue") || "null")
  );
  const [selectedValuesub, setSelectedValuesub] = useState<Question | null>(
    () => JSON.parse(sessionStorage.getItem("selectedValuesub") || "null")
  );

  const [selectedLevel, setSelectedLevel] = useState<YearList | null>(() =>
    JSON.parse(sessionStorage.getItem("selectedLevel") || "null")
  );
  // const [selectedLevel, setSelectedLevel] = useState<DifficultyOption | null>(
  //   () => JSON.parse(sessionStorage.getItem("selectedLevel") || "null")
  // );

  const [formValues, setFormValues] = useState(() => {
    return (
      JSON.parse(sessionStorage.getItem("formValues") || "{}") || {
        question: "",
        prompt: "",
        instruction: "",
      }
    );
  });

  // question count

  // const [currentPage, setCurrentPage] = useState(1); // Start from page 1
  // const pageSize = 20;

  // const handleNext = () => {
  //   const nextPage = currentPage + 1;
  //   setCurrentPage(nextPage);

  //   const payload: any = { page: nextPage, page_size: 20 };

  //   if (selectedLevel) {
  //     payload.year_level = selectedLevel.value;
  //     // payload.year_level = selectedLevel.value;
  //   }
  //   if (selectedValue) {
  //     payload.questionType = selectedValue.value;
  //   }
  //   if (selectedValuesub) {
  //     payload.subType = selectedValuesub.value;
  //   }
  //   if (formValues.question || formValues.prompt || formValues.instruction) {
  //     payload.question = formValues.question;
  //     payload.prompt = formValues.prompt;
  //     payload.instruction = formValues.instruction;
  //   }

  //   // If at least one field is filled, dispatch API call
  //   dispatch(listQuestions(Object.keys(payload).length > 0 ? payload : {}));
  // };

  // const handlePrevious = () => {
  //   if (currentPage > 1) {
  //     const prevPage = currentPage - 1;
  //     setCurrentPage(prevPage);

  //     const payload: any = { page: prevPage, page_size: 20 };

  //     if (selectedLevel) {
  //       payload.year_level = selectedLevel.value;
  //       // payload.year_level = selectedLevel.value;
  //     }
  //     if (selectedValue) {
  //       payload.questionType = selectedValue.value;
  //     }
  //     if (selectedValuesub) {
  //       payload.subType = selectedValuesub.value;
  //     }
  //     if (formValues.question || formValues.prompt || formValues.instruction) {
  //       payload.question = formValues.question;
  //       payload.prompt = formValues.prompt;
  //       payload.instruction = formValues.instruction;
  //     }

  //     // If at least one field is filled, dispatch API call
  //     dispatch(listQuestions(Object.keys(payload).length > 0 ? payload : {}));
  //   }
  // };
  // Function to trigger API call with proper conditions
  const triggerApiCall = (pageNumber = page) => {
    const payload: any = {
      page: pageNumber,
      page_size: pageSize,
      status: isActive,
    };

    if (selectedLevel) payload.year_level = selectedLevel.value;
    if (selectedValue) payload.questionType = selectedValue.value;
    if (selectedValuesub) payload.subType = selectedValuesub.value;

    if (formValues.question || formValues.prompt || formValues.instruction) {
      payload.question = formValues.question;
      payload.prompt = formValues.prompt;
      payload.instruction = formValues.instruction;
    }

    dispatch(listQuestions(payload));
  };

  useEffect(() => {
    triggerApiCall();
  }, [
    selectedValue,
    selectedValuesub,
    selectedLevel,
    formValues,
    addQuestions,
    EditQuestions,
    deleteQuestionss,
    bulkUploadResponse,
  ]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    triggerApiCall(newPage);
  };

  const handleChange =
    (field: "question" | "prompt" | "instruction") =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFormValues((prev: any) => {
          const updated = { ...prev, [field]: value };
          sessionStorage.setItem("formValues", JSON.stringify(updated));
          return updated;
        });
      };

  const handleBulkUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      dispatch(bulkUploadQuestions(event.target.files[0]));
      // Reset the value so the same file can be selected again if needed
      event.target.value = '';
    }
  };

  const ListYearSliceLoading = useAppSelector(
    (state) => state.ListYearlevel_mapSlice
  );
  const ListYear = ListYearSliceLoading?.data;

  const YearList = Array.isArray(ListYear?.data)
    ? ListYear?.data?.map((listExams) => ({
      label: `${listExams?.yeargroup?.name!} - ${listExams?.region?.state}, ${listExams?.region?.name}`,
      value: listExams?.id!,
    }))
    : [];
  const { data: listQuestionssub } = useAppSelector(
    (state) => state.ListQuestionSubTypeSlice
  );
  const QuestionsubList = Array.isArray(listQuestionssub?.data)
    ? listQuestionssub?.data
      ?.filter((role) => role.status !== false) // Filter out roles where status is false
      .map((listQuestions) => ({
        label: listQuestions?.subtype_name!,
        value: listQuestions.id,
      }))
    : [];
  useEffect(() => {
    if (selectedValue) {
      dispatch(listQuestionSubType({ questiontype_id: selectedValue?.value }));
    }
  }, [selectedValue]);

  const handleExport = async (format: "csv" | "xlsx") => {
    setIsExporting(true);
    try {
      const { utils, writeFile } = await import("xlsx");
      let allQuestions: any[] = [];
      let currentPageNum = 1;
      let totalPagesFetch = 1;

      // Base payload derived from current filter state
      const basePayload: any = {
        status: isActive,
      };

      if (selectedLevel) basePayload.year_level = selectedLevel.value;
      if (selectedValue) basePayload.questionType = selectedValue.value;
      if (selectedValuesub) basePayload.subType = selectedValuesub.value;

      if (formValues.question || formValues.prompt || formValues.instruction) {
        basePayload.question = formValues.question;
        basePayload.prompt = formValues.prompt;
        basePayload.instruction = formValues.instruction;
      }

      // Fetch sequentially in chunks of 100
      do {
        const response = await api.post("/api/question/", basePayload, {
          params: { page: currentPageNum, page_size: 100 },
        });

        const resData = response.data;
        const payload = resData?.data || resData; // Support both wrapped and direct structures 

        if (payload && payload.questions && Array.isArray(payload.questions)) {
          allQuestions = [...allQuestions, ...payload.questions];
        }

        totalPagesFetch = payload?.pagination?.total_pages || 1;
        currentPageNum++;

      } while (currentPageNum <= totalPagesFetch);

      // Cleanse and format the data
      const dataToExport = allQuestions.map((row: any, index: number) => {
        return {
          "S.No": index + 1,
          "Question": row.question || "-",
          "Sub Type": row.subType_name || "-",
          "Question Type Name": row.Question_type_name || "-",
          "Prompt": row.prompt || "-",
          "Instruction": row.instruction || "-",
          "Explanation": row.explanation || "-",
          "Source Type": row.source_type || "-",
          "Status": row.state === "active" ? "Active" : "Inactive"
        };
      });

      const worksheet = utils.json_to_sheet(dataToExport);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "Questions");

      const fileName = `Questions_Export_${new Date().toLocaleDateString()}.${format}`;
      writeFile(workbook, fileName, { bookType: format });

    } catch (error) {
      console.error("Failed to export all questions:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%", width: "100%" }}>
        <Table
          rows={visibleQuestions}
          columns={columns}
          exportFileName="Questions"
          paginationMode="server"
          currentPage={currentPage}
          totalPage={totalPages}
          pageSize={pageSize}
          rowCount={pagination?.total_count ?? 0}
          onPageChange={handlePageChange}
          pageSizeOptions={[20]}
          isExporting={isExporting}
          onExport={handleExport}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
        >
          <CustomToolbar sx={{ flexWrap: "wrap", justifyContent: "flex-end" }}>
            <Box
              sx={{
                display: "grid",
                gap: "10px",
                width: "100%",
                order: 1,
                marginBottom: "10px",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  sm: "repeat(6, 1fr)"
                }
              }}
            >
              <FormControl
                size="small"
                variant="outlined"
                sx={{ position: "relative" }}
              >
                <InputLabel id="question-select-label">
                  Select Question Type
                </InputLabel>
                <Select
                  label="Select Question Type"
                  labelId="question-select-label"
                  value={selectedValue ? selectedValue.value : ""}
                  onChange={(e) => {
                    const selected =
                      QuestionList?.find(
                        (q: any) => q?.value === e.target.value
                      ) || null;
                    setSelectedValue(selected);
                    dispatch(
                      listQuestionSubType({ questiontype_id: selected?.value })
                    );
                    sessionStorage.setItem(
                      "selectedValue",
                      JSON.stringify(selected)
                    );
                    setSelectedLevel(null);
                    setFormValues({ question: "", prompt: "", instruction: "" });
                    sessionStorage.setItem(
                      "formValues",
                      JSON.stringify({
                        question: "",
                        prompt: "",
                        instruction: "",
                      })
                    );
                  }}
                >
                  {QuestionList?.length > 0 ? (
                    QuestionList?.map((question: any) => (
                      <MenuItem key={question.value} value={question.value}>
                        {question.label}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Questions Available</MenuItem>
                  )}
                </Select>

                {selectedValue && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      right: 5,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      marginRight: "15px",
                    }}
                    onClick={() => {
                      setSelectedValue(null);
                      sessionStorage.removeItem("selectedValue");
                      setSelectedLevel(null);
                      setSelectedValuesub(null);
                      setFormValues({
                        question: "",
                        prompt: "",
                        instruction: "",
                      });
                      sessionStorage.setItem(
                        "formValues",
                        JSON.stringify({
                          question: "",
                          prompt: "",
                          instruction: "",
                        })
                      );
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </FormControl>

              <FormControl
                size="small"
                variant="outlined"
                sx={{ position: "relative" }}
              >
                <InputLabel id="questionsub-select-label">
                  Select Question SubType
                </InputLabel>
                <Select
                  label="Select Question SubType"
                  labelId="questionsub-select-label"
                  value={selectedValuesub ? selectedValuesub.value : ""}
                  onChange={(e) => {
                    const selected: any =
                      QuestionsubList?.find(
                        (q: any) => q?.value === e.target.value
                      ) || null;
                    setSelectedValuesub(selected);
                    sessionStorage.setItem(
                      "selectedValuesub",
                      JSON.stringify(selected)
                    );
                  }}
                >
                  {(QuestionsubList?.length ?? 0) > 0 ? (
                    QuestionsubList?.map((question: any) => (
                      <MenuItem key={question.value} value={question.value}>
                        {question.label}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Questions Subtype Available</MenuItem>
                  )}
                </Select>

                {selectedValuesub && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      right: 5,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      marginRight: "15px",
                    }}
                    onClick={() => {
                      setSelectedValuesub(null);
                      sessionStorage.removeItem("selectedValuesub");
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </FormControl>

              <FormControl
                size="small"
                variant="outlined"
                sx={{ position: "relative" }}
              >
                <InputLabel id="difficulty-select-label">
                  Select Year Level
                </InputLabel>
                <Select
                  label="Select Year Level"
                  labelId="difficulty-select-label"
                  value={selectedLevel ? selectedLevel.value : ""}
                  onChange={(e) => {
                    const selected =
                      YearList?.find((q: any) => q?.value === e.target.value) ||
                      null;
                    setSelectedLevel(selected);
                    sessionStorage.setItem(
                      "selectedLevel",
                      JSON.stringify(selected)
                    );
                  }}
                >
                  {YearList ? (
                    YearList.map((question: any) => (
                      <MenuItem key={question.value} value={question.value}>
                        {question.label}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Questions Available</MenuItem>
                  )}
                </Select>

                {selectedLevel && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      right: 5,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      marginRight: "15px",
                    }}
                    onClick={() => {
                      setSelectedLevel(null);
                      sessionStorage.removeItem("selectedLevel");
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </FormControl>

              <TextField
                size="small"
                id="question-field"
                label="Question"
                variant="outlined"
                value={formValues.question}
                onChange={handleChange("question")}
              />
              <TextField
                size="small"
                id="prompt-field"
                label="Prompt"
                variant="outlined"
                value={formValues.prompt}
                onChange={handleChange("prompt")}
              />
              <TextField
                size="small"
                id="instruction-field"
                label="Instruction"
                variant="outlined"
                value={formValues.instruction}
                onChange={handleChange("instruction")}
              />
            </Box>

            <div style={{ display: "flex", gap: "10px", order: 3 }}>
              <ButtonGroup
                variant="contained"
                className="active_Btn"
                sx={{
                  border: "none",
                  "& .MuiButton-root": {
                    border: "none",
                  },
                }}
              >
                <Button
                  className="active_Btn"
                  onClick={() => setIsActive(true)}
                  sx={{
                    backgroundColor: isActive === true ? "#1976d2" : "#fff",
                    color: isActive === true ? "#fff" : "#000",
                    "&:hover": {
                      backgroundColor: isActive === true ? "#1976d2" : "#f5f5f5",
                    },
                  }}
                >
                  Active
                </Button>

                <Button
                  onClick={() => setIsActive(false)}
                  sx={{
                    backgroundColor: isActive === false ? "#1976d2" : "#fff",
                    color: isActive === false ? "#fff" : "#000",
                    "&:hover": {
                      backgroundColor: isActive === false ? "#1976d2" : "#f5f5f5",
                    },
                  }}
                >
                  Inactive
                </Button>
              </ButtonGroup>

              <ButtonField
                disabled={finaldata?.permissions?.add === false}
                className="tabel_add_new_button"
                onClick={() => {
                  setInitialValues({ Status: true });
                  setIsEdit(false);
                  setDialogOpen(true);
                }}
                toolTip="Add new"
              >
                Add new
              </ButtonField>

              <ButtonField
                disabled={finaldata?.permissions?.add === false}
                className="tabel_add_new_button"
                onClick={() => setBulkUploadInfoOpen(true)}
                toolTip="Bulk Upload"
              >
                Bulk Upload
              </ButtonField>

              <IconButtonField
                className="refresh_btn"
                toolTip="Refresh"
                onClick={() => triggerApiCall()}
              >
                <SvgIcon
                  className="refresh_svg_icon"
                  component={RefreshButton}
                  inheritViewBox
                />
              </IconButtonField>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xlsx, .xls, .zip"
              onChange={handleBulkUpload}
            />
          </CustomToolbar>
        </Table>
      </div>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Questions`}
        Dialog_Content={
          <QuestionsForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog response={addQuestions} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditQuestions} parentDialog={setDialogOpen} />
      <ResponseDialog response={bulkUploadResponse} parentDialog={() => { }} />

      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteQuestions(deleteDialogData.id));
        }}
        response={deleteQuestionss}
      />

      <Dialog
        open={bulkUploadInfoOpen}
        setOpen={setBulkUploadInfoOpen}
        Dialog_Title="Bulk Upload Instructions"
        Dialog_Content={
          <div style={{ padding: "10px" }}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <AlertTitle><strong>Guidelines</strong></AlertTitle>
              Please follow the same structure exactly while preparing the file.
            </Alert>

            <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, overflowY: 'auto', maxHeight: '400px' }}>
              <ListItem>
                <ListItemText
                  primary={<strong>1. Question Text</strong>}
                  secondary="Add the actual question here. Whatever the learner sees as the question on the UI should come here, no shortcuts."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>2. Question Type</strong>}
                  secondary="Enter the section name or category here (e.g., 'Writing - Part A'). This is used for grouping and section headers. It is NO LONGER used to determine if the question is Drag & Drop or MCQ, so you can name it anything."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>2.1 Answer Type (New)</strong>}
                  secondary={<span>Optional but recommended. Enter the functional type of the question here: <strong>Drag & Drop</strong>, <strong>True/False</strong>, <strong>Table</strong>, <strong>Fill Blank</strong>, or <strong>MCQ</strong>. If left empty, the system defaults to checking 'Question Type', but using this column allows you to have custom section names in 'Question Type'.</span>}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>3. Prompt</strong>}
                  secondary="Prompt is basically the supporting content for the question. Whatever prompt you have for the question in the UI, that content should be added here."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>4. Instruction</strong>}
                  secondary="This is the instruction shown to the user on the UI – for example, how to answer the question. Whatever instruction logic you already have in the UI, the same should be maintained here."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>5. Explanation</strong>}
                  secondary="This field is used to explain the correct answer. It will be shown after answering, so add a clear and meaningful explanation here."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>6. Difficulty Level</strong>}
                  secondary="Define how difficult the question is – easy, medium, hard – based on your existing standards."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>7. Year Level and Region</strong>}
                  secondary="These two should strictly follow the same format that is already used in the Excel. Please don’t change formats or naming conventions here."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>8. Group ID</strong>}
                  secondary="Mainly for grouped questions. Multiple questions sharing the same reading passage should share the same group ID (e.g., g1, g1). Next set uses g2, etc."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>9. Is Main</strong>}
                  secondary={<span>For the main question (e.g., passage), set this as <strong>TRUE</strong>. For sub-questions under it, set as <strong>FALSE</strong>. For standalone questions, keep as <strong>TRUE</strong>.</span>}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>10. Images (Question & Prompt)</strong>}
                  secondary="If the question/prompt has an image, add the image file name in the respective column (e.g. 'cat.jpg')."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={<strong>11. Options / Items</strong>}
                  secondary={
                    <span>
                      Fields like <strong>Option 1 Text</strong> (renamed from Option 1), Option 1 Correct, etc. are mandatory.
                      <ul>
                        <li><strong>Option Text</strong>: The text for the option or drag item.</li>
                        <li><strong>Option Image</strong>: Image file name if applicable.</li>
                        <li><strong>Option Correct</strong>:
                          <ul>
                            <li>For MCQ: TRUE or FALSE.</li>
                            <li>For Drag & Drop: The <strong>Target Bucket Name</strong> (e.g., 'Mammal').</li>
                          </ul>
                        </li>
                      </ul>
                    </span>
                  }
                />
              </ListItem>
              <ListItem sx={{ bgcolor: '#fff3e0' }}>
                <ListItemIcon>
                  <ReportGmailerrorredIcon color="warning" />
                </ListItemIcon>
                <ListItemText
                  primary={<strong>Important Note</strong>}
                  secondary="All images mentioned in the Excel must be added using their file names, and all those image files must be included inside the ZIP folder while uploading. If an image is missing, the upload will fail. Cross-verify spellings, formats, boolean values, and group IDs."
                />
              </ListItem>
            </List>

            <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CloudDownloadIcon />}
                size="large"
                sx={{
                  borderRadius: "8px",
                  padding: "10px 24px",
                  textTransform: "none",
                  fontWeight: "bold",
                  boxShadow: 3,
                  "&:hover": {
                    backgroundColor: "info.dark",
                    boxShadow: 4,
                  }
                }}
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = `${process.env.REACT_APP_API_URL}/api/question/bulk-upload-sample`;
                  link.setAttribute('download', 'bulk_insert.zip');
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                Download Sample Zip
              </Button>
            </div>
          </div>
        }
        Dialog_Actions={
          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setBulkUploadInfoOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setBulkUploadInfoOpen(false);
                fileInputRef.current?.click();
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "info.dark",
                }
              }}
            >
              Proceed to Upload
            </Button>
          </div>
        }
      />

      {(previewType === "ucat" || previewType === "online") && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#fff",
          zIndex: 2000,
          overflow: "auto"
        }}>
          {previewType === "ucat" ? (
            <UcatExamTemplate
              previewData={previewItem}
              onBack={() => setPreviewType(null)}
            />
          ) : (
            <OnlineExamTamplete
              previewData={previewItem}
              onBack={() => setPreviewType(null)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Questions;
